import type { DayPickerProps } from 'react-day-picker';

import VDatePickerMoveMonthButton from './VDatePickerMoveMonthButton';
import style from './style';

export enum DATEPICKER_MODE {
  SINGLE = 'single',
  RANGE = 'range',
}

export const DAYPICKER_BASE_PROPS = {
  captionLayout: 'dropdown',
  classNames: style.DayPickerCustom,
  components: {
    Weekday(props) {
      const { children, ...rest } = props;
      return <th {...rest} children={(children as string)[0]} />;
    },
    NextMonthButton: props => (
      <VDatePickerMoveMonthButton {...props} dir="next" />
    ),
    PreviousMonthButton: props => (
      <VDatePickerMoveMonthButton {...props} dir="prev" />
    ),
  },
  showOutsideDays: true,
  fromYear: 2000,
  toYear: 2050,
} as DayPickerProps;
